import { Lock, User } from 'lucide-react';

export const LoginForm = ({ 
  isArabic, 
  credentials, 
  setCredentials, 
  onSubmit, 
  loginError 
}) => (
  <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4" dir={isArabic ? 'rtl' : 'ltr'}>
    <div className="bg-white rounded-2xl shadow-xl p-8 w-full max-w-md">
      <div className="text-center mb-8">
        <div className="w-16 h-16 bg-black rounded-2xl flex items-center justify-center mx-auto mb-4">
          <Lock className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-2xl font-bold text-slate-900">
          {isArabic ? 'لوحة التحكم' : 'Admin Panel'}
        </h1>
        <p className="text-slate-500 mt-2">
          {isArabic ? 'قم بتسجيل الدخول للمتابعة' : 'Sign in to continue'}
        </p>
      </div>

      <form onSubmit={onSubmit} className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            {isArabic ? 'اسم المستخدم' : 'Username'}
          </label>
          <div className="relative">
            <User className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
            <input
              type="text"
              value={credentials.username}
              onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
              className="w-full pl-4 pr-12 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-black focus:border-transparent"
              placeholder="admin"
              data-testid="login-username"
              required
            />
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-2">
            {isArabic ? 'كلمة المرور' : 'Password'}
          </label>
          <div className="relative">
            <Lock className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 text-slate-400" />
            <input
              type="password"
              value={credentials.password}
              onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
              className="w-full pl-4 pr-12 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-black focus:border-transparent"
              placeholder="••••••••"
              data-testid="login-password"
              required
            />
          </div>
        </div>

        {loginError && (
          <div className="bg-red-50 text-red-600 px-4 py-3 rounded-xl text-sm">
            {loginError}
          </div>
        )}

        <button
          type="submit"
          className="w-full py-3 bg-black text-white rounded-xl font-medium hover:bg-slate-800 transition-colors"
          data-testid="login-submit"
        >
          {isArabic ? 'تسجيل الدخول' : 'Sign In'}
        </button>
      </form>
    </div>
  </div>
);
